var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinks2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 145.5 145.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 21.35,
    y1: 124.15,
    x2: 124.15,
    y2: 21.35,
    gradientTransform: "translate(121.8 -17.69) rotate(73.47)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9748a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d163ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 40.66,
    y1: 104.74,
    x2: 104.84,
    y2: 40.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#edbede"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 72.75,
    cy: 72.75,
    r: 72.75,
    transform: "translate(-17.69 121.8) rotate(-73.47)",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.65,57.98c.98,.98,.97,2.56,0,3.54l-26.04,26c-.49,.49-1.13,.73-1.77,.73s-1.28-.24-1.77-.73c-.98-.98-.97-2.56,0-3.54l26.04-26c.98-.98,2.56-.97,3.54,0Zm17.22-17.41c-8.02-8.01-21.56-8.01-29.61,.03l-10.98,11.39c-.96,.99-.93,2.58,.07,3.54,.99,.96,2.58,.93,3.54-.07l10.94-11.36c6.1-6.09,16.41-6.09,22.51,0,2.96,2.96,4.59,6.95,4.59,11.23s-1.63,8.28-4.59,11.23l-11.19,11.18c-.98,.98-.98,2.56,0,3.54,.49,.49,1.13,.73,1.77,.73s1.28-.24,1.77-.73l11.19-11.18c3.91-3.9,6.06-9.15,6.06-14.77s-2.15-10.87-6.06-14.77Zm-26.99,49.43l-11.19,11.18c-6.1,6.09-16.41,6.09-22.51,0-2.96-2.96-4.59-6.95-4.59-11.23s1.63-8.28,4.59-11.23l11.19-11.18c.98-.98,.98-2.56,0-3.54-.98-.98-2.56-.98-3.54,0l-11.19,11.18c-3.91,3.9-6.06,9.15-6.06,14.77s2.15,10.87,6.06,14.77c4.01,4,9.4,6,14.79,6s10.78-2,14.79-6l11.19-11.18c.98-.98,.98-2.56,0-3.54-.98-.98-2.56-.98-3.54,0Z",
    fill: "url(#e)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinks2);
export default __webpack_public_path__ + "static/media/links-2.d286944764090ea04c05f2dedc049fca.svg";
export { ForwardRef as ReactComponent };